import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Collapse,
  Label,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import { Link } from "react-router-dom";
import CreatableSelect from "react-select/lib/Creatable";
import Select from "react-select";
import Info from "../NewManageUsers/ManagePane/InfoCard/InfoBlockComponents/Info";
import TextArea from "./TextArea";
import NewContentCard from "../../Content/ManageContentComponents/NewContentCard";
import {
  ItemBasicNav,
  ItemQuestion,
  ItemAnswers
} from "../../Assessment/AssessTest";

import ItemData from "./AuthorItem/ItemData";
import EditNodes from "./EditNodes";

export default class AuthorItem extends React.Component {
  state = {
    item: null,
    showModal: false,
    editNode: false,
    activeCard : '',
    nodes: [
      { subcourseId: "01", name: "abc" },
      { subcourseId: "01", name: "sdf" },
      { subcourseId: "01", name: "sdsf" },
      { subcourseId: "01", name: "Challenger" },
      { subcourseId: "01", name: "mastery" },
      { subcourseId: "01", name: "asd" },
      { subcourseId: "01", name: "asdfsa" }
    ]
  };

  componentWillMount() {
    //Dummy item
    const dummyItem = {
      index: 1,
      itemCode: `ACT-E-Q-1`,
      itemType: "Multiple Choice",
      preview: `Oh, king eh? Very nice. 
                        And how'd you get that, 
                        eh? By exploiting the workers. 
                        <span class='underlined_item'>By hanging on to outdated</span> imperialist dogma 
                        which perpetuates the economic and social differences 
                        in our society. If there's ever gonna be any progress...`,
      tags: "hard-question, mess-these-kids-up, questionable-answer",
      nodes: `Writer's Goal`,
      answerChoices: {
        answer001: "Bring out your dead",
        answer002: `Well you can't expect to wield supreme executive power just 'cause some watery tart threw a sword at you!`,
        answer003: `Come back here and take what's coming to you. I'll bite your legs off!`,
        answer004: `All right, all right, not biscuits, but lets kill him anyway.`
      }
    };

    this.setState({
      item: dummyItem
    });
  }
  handleDeleteSection = () => {
    this.setState({ showModal: false });
    console.log("item deleted successfully!!!");
  };

  toggleRightCol = (activeCard) => {
    this.setState(state => ({ activeCard : activeCard === state.activeCard ? '' : activeCard }))
}

  showModal = (course, type, confirmAction) => {
    let modalText = "";
    let desc = "";
    // let modalAction;
    if (type === "delete" && course.itemCode) {
      modalText = `Attempting to delete (${course.itemCode}). 
      Are you sure you want to delete this ${course.itemCode}? 
      This action cannot be reversed. All data will be lost.`;
      
      desc = "Delete";
    } 
    
    this.setState({
      showModal: true,
      modalText,
      desc,
      selectedSectionName: course.name,
      courseId: course.id,
      ...confirmAction
    });
  };

  getModal() {
    return (
      <Modal
        isOpen={this.state.showModal}
        className={
          this.state.desc === "Delete" ? `modal-danger` : `modal-success`
        }
      >
        <ModalHeader
          style={
            this.state.desc !== "Delete" ? { backgroundColor: "#1c2930" } : {}
          }
        >
          {this.state.desc} Section
        </ModalHeader>
        <ModalBody>
          {this.state.modalText}
          {this.state.desc === "Parent" ? (
            <div>
              <span
                style={{
                  color: "#375160",
                  fontSize: "17px",
                  fontWeight: "bold"
                }}
              >
                Section:
              </span>
              <Select />
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => this.state.confirmAction()} color="secondary">
            {this.state.desc === "Parent" ? "Move" : this.state.desc}
          </Button>
          <Button
            onClick={() => this.setState({ showModal: false })}
            color="secondary"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const { item, nodes, activeCard } = this.state;
    return (
      <Card className="course-edit-container">
        <span className="breadcrums">
          {`< View All Items`} <br /> {`< Back`}{" "}
        </span>
        <Row>
          <Col md="8" sm="8">
            <h3 className="heading">
              Edit Item <span className="name">{item.itemCode} </span>
              <i
                onClick={() =>
                  this.showModal(item, "delete", {
                    confirmAction: this.handleDeleteSection
                  })
                }
                className="icon-delete-button"
              />{" "}
            </h3>
          </Col>
          <Col md="4" sm="4">
            <Button
              style={{ float: "right", margin: "20px 0 20px 0" }}
              className="add-btn"
              size="sm"
            >
              + Create New Item
            </Button>
          </Col>
        </Row>
        {this.getModal()}
        <Row>
          <Col style={{ overflowY: "auto" }} md={6} xs={12}>
            <ItemData nodes={nodes} toggleCard={this.toggleRightCol} item={item} />
          </Col>
          <Col md={6} xs={12}>
            {activeCard === "editNode" && (
              <EditNodes
                closeEditNode={this.toggleRightCol}
                onUpdateNodes={nodes =>
                  this.setState({ nodes }, () => this.toggleRightCol)
                }
              />
            )}
          </Col>
        </Row>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItem.js